export enum FeeType {
  PERCENTAGE = 'percentage',
  AMOUNT = 'amount'
}
